import { useMutation, useQueryClient } from 'react-query'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

export default function useUpdateAnnouncement () {
  const queryClient = useQueryClient()

  return useMutation(
    async (values) => {
      const { id, ...rest } = values
      const updatedAnnouncement = await axios.put(`${getApiServer()}/announcements/${id}`, rest, { withCredentials: true })
      return updatedAnnouncement.data
    }, {
      onMutate: (values) => {
        const currentAnnouncements = queryClient.getQueryData('announcements')
        const announcementIndex = currentAnnouncements.findIndex((announcement) => announcement.Id === values.id)
        const announcement = {
          Description: values.description,
          EndDate: values.endDate,
          Link: values.link,
          Title: values.title,
          Id: values.id
        }
        queryClient.setQueryData('announcements', [
          ...currentAnnouncements.slice(0, announcementIndex),
          announcement,
          ...currentAnnouncements.slice(announcementIndex + 1)
        ])
      },
      onSuccess: async () => {
        await queryClient.refetchQueries('announcements')
      }
    }
  )
}